import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

export const TWINKLE_STARS = Array.from({ length: 24 }, (_, i) => ({
  id: i,
  left: `${(i * 17 + 7) % 100}%`,
  top: `${(i * 23 + 11) % 100}%`,
  size: i % 3 === 0 ? 2 : 1,
  delay: (i % 5) * 0.4,
  duration: 1.6 + (i % 4) * 0.5,
}));

interface TwinklingStarsProps {
  count?: number;
  className?: string;
}

const TwinklingStars: React.FC<TwinklingStarsProps> = ({
  count = TWINKLE_STARS.length,
  className = "",
}) => {
  const reduceMotion = useReducedMotion();
  const stars = useMemo(() => TWINKLE_STARS.slice(0, count), [count]);

  return (
    <div
      className={`pointer-events-none absolute inset-0 ${className}`}
      aria-hidden
    >
      {stars.map((star) =>
        reduceMotion ? (
          <span
            key={star.id}
            className="absolute rounded-full bg-white opacity-40"
            style={{
              left: star.left,
              top: star.top,
              width: star.size,
              height: star.size,
            }}
          />
        ) : (
          <motion.span
            key={star.id}
            className="absolute rounded-full bg-white"
            style={{
              left: star.left,
              top: star.top,
              width: star.size,
              height: star.size,
            }}
            animate={{ opacity: [0.15, 0.9, 0.15], scale: [1, 1.4, 1] }}
            transition={{
              duration: star.duration,
              repeat: Infinity,
              delay: star.delay,
              ease: "easeInOut",
            }}
          />
        ),
      )}
    </div>
  );
};

export default TwinklingStars;
